window.okeReviewsWidgetOnInit = function () {
    // Move Reviews Aggregate above Navbar
    const reviewsAggregate = document.querySelector('.okeReviews-reviewsWidget-reviewsAggregate');
    const customAggregateHolder = document.querySelector('#okeReviews-aggregateHolder');
    if (reviewsAggregate && customAggregateHolder) {
        customAggregateHolder.insertAdjacentElement('afterbegin', reviewsAggregate);
    }

    // Setup Mutation Observer for individual reviews
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupIndividualReview(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, { childList: true });

        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupIndividualReview(n));
    }
};

window.okeReviewsQandaOnInit = function () {
    const questionMain = document.querySelector('.js-okeReviews-questions-main');
    if (questionMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => formatDateForElement(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(questionMain, { childList: true });

        const questions = document.querySelectorAll('.okeReviews-question');
        questions.forEach(n => formatDateForElement(n));
    }
};

function setupIndividualReview(reviewElement) {
    const reviewerAttribute = reviewElement.querySelector('.okeReviews-review-reviewer-attributes');
    const reviewArguments = reviewElement.querySelector('.okeReviews-review-arguments');
    const reviewPrimary = reviewElement.querySelector('.okeReviews-review-primary');
    if (reviewerAttribute) {
        reviewPrimary.insertAdjacentElement('afterbegin', reviewerAttribute);
    }
    if (reviewArguments) {
        reviewPrimary.insertAdjacentElement('afterbegin', reviewArguments);
    }

    const reviewerName = reviewElement.querySelector('.okeReviews-review-reviewer-profile-details');
    const reviewRating = reviewElement.querySelector('.okeReviews-review-meta');
    reviewerName.insertAdjacentElement('afterbegin', reviewRating);
    formatDateForElement(reviewElement);
}

// Change relative time format into format: MM/DD/YYYY
function formatDateForElement(nodeElement) {
    if (nodeElement) {
        const reviewDates = nodeElement.querySelectorAll('[data-oke-reviews-date]');
        for (const reviewDate of reviewDates) {
            const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
            const date = new Date(dateIsoString);
            const localeDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            reviewDate.innerText = localeDate;
        }
    }
}